"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var DetailsHeader_base_1 = require("./DetailsHeader.base");
var DetailsHeader_styles_1 = require("./DetailsHeader.styles");
exports.DetailsHeader = Utilities_1.styled(DetailsHeader_base_1.DetailsHeaderBase, DetailsHeader_styles_1.getStyles, undefined, { scope: 'DetailsHeader' });
//# sourceMappingURL=DetailsHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DetailsList/DetailsHeader.js
// module id = 871
// module chunks = 0